import { ISuppliersResult } from 'API/Suppliers/suppliers';
import { ITherapyFilters } from 'Context/SuppliersContext/TherapySuppliersContext';
import { getHaversineDistance } from 'Utils/getHaversineDistance';
import { getShortestTwoCoordinates } from './SuppliersReducer';
import { FEMALE_ID, MALE_ID } from 'Config';

export function DoctorFilter(
  data: ISuppliersResult[],
  filters: ITherapyFilters
) {
  const {
    supName,
    city,
    accessible,
    lng,
    gender,
    homeVisit,
    orderByAscendingAlphabet,
    orderByDescendingAlphabet,
    location,
  } = filters;

  const filterByName = supName
    ? data.filter((therapyItem: ISuppliersResult) =>
        therapyItem.name.includes(supName)
      )
    : data;

  const filterByCity =
    city && city.length > 0
      ? filterByName.filter(
          (therapyItem: ISuppliersResult) =>
            (therapyItem.firstCityId &&
              city.includes(therapyItem.firstCityId)) ||
            (therapyItem.secondCityId &&
              city.includes(therapyItem.secondCityId))
        )
      : filterByName;

  const filterByAccessible = accessible
    ? filterByCity.filter(
        (therapyItem: ISuppliersResult) =>
          therapyItem.hasAccessibilityForHandicapped
      )
    : filterByCity;

  const filterByLanguages =
    lng && lng.length > 0
      ? filterByAccessible.filter((therapyItem: ISuppliersResult) =>
          therapyItem.languages.some((languageId: number) =>
            lng.includes(languageId)
          )
        )
      : filterByAccessible;

  const filterByGender =
    gender === MALE_ID || gender === FEMALE_ID
      ? filterByLanguages.filter(
          (therapyItem: ISuppliersResult) => therapyItem.gender === gender
        )
      : filterByLanguages;

  const filterByHomeVisit = homeVisit
    ? filterByGender.filter(
        (therapyItem: ISuppliersResult) => therapyItem.hasHomeVisit
      )
    : filterByGender;

  if (orderByAscendingAlphabet)
    filterByHomeVisit.sort((a: ISuppliersResult, b: ISuppliersResult) =>
      a.name.localeCompare(b.name)
    );
  if (orderByDescendingAlphabet)
    filterByHomeVisit.sort((a: ISuppliersResult, b: ISuppliersResult) =>
      b.name.localeCompare(a.name)
    );

  const filteredByLocation = location
    ? filterByHomeVisit.filter(
        (therapyItem: ISuppliersResult) =>
          (therapyItem.firstLatitude && therapyItem.firstLongitude) ||
          (therapyItem.secondLatitude && therapyItem.secondLongitude)
      )
    : filterByHomeVisit;

  const filterByDistance = location
    ? filteredByLocation.sort((a: ISuppliersResult, b: ISuppliersResult) => {
        const { coordsA, coordsB } = getShortestTwoCoordinates(location, a, b);
        if (coordsA && coordsB)
          return (
            getHaversineDistance(location, coordsA) -
            getHaversineDistance(location, coordsB)
          );
        return 0;
      })
    : filteredByLocation;

  const filteredTherapy = [
    ...new Set([...filterByDistance, ...filterByHomeVisit]),
  ];

  return filteredTherapy;
}
